import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptAnnouncements } from "../adapters/adaptAnnouncements";

const fetchAnnouncements = async (): Promise<IAnnouncement[]> => {
	const response = await cmsClient.get("/announcements/");
	const data = response.data;
	if (Array.isArray(data)) return data;
	if (data && Array.isArray(data.results)) return data.results;
	return [];
};

const useAnnouncements = () => {
	const query = useQuery(["announcements"], fetchAnnouncements, {
		select: adaptAnnouncements
	});
	return query;
};

export default useAnnouncements;
